import { TermsComponent } from "@app/feature/external/terms/terms.component";
// import { AccountModule } from './feature/external/account/account.module';
import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PageNotFoundComponent } from "./feature/external/page-not-found/page-not-found.component";
import { PublicPageComponent } from "./feature/external/public-page/public-page.component";
import { TechBuyerModule } from "./feature/main/tech-buyer/tech-buyer.module";

import { TechVendorModule } from "./feature/main/tech-vendor/tech-vendor.module";
import { RoutingGuardService } from "@app/shared/services/routing-guard.service";
import { HomeRoutingGuardService } from "@app/shared/services/Home-guard.service";
import { AuthGuard } from "@app/shared/services/auth-guard.service";
import { ContactUsComponent } from "@app/feature/main/roles-shared/components/contact-us/contact-us.component";
import { BlogsComponent } from "@app/feature/main/roles-shared/components/blogs/blogs.component";
import { AllResearchComponent } from "@app/feature/main/roles-shared/components/all-research/all-research.component";
import { AnalystListComponent } from "@app/feature/main/roles-shared/components/analyst-list/analyst-list.component";
import { UnderConstructionComponent } from "@app/feature/main/roles-shared/components/under-construction/under-construction.component";
import { SupportComponent } from "@app/feature/main/roles-shared/components/support/support.component";
import { ReportsComponent } from "@app/feature/main/roles-shared/components/reports/reports.component";
import { TechAnalystProfileComponent } from "@app/shared/components/tech-analyst-profile/tech-analyst-profile.component";
import { TechAnalystModule } from "./feature/main/tech-analyst/tech-analyst.module";
import { EcosystmStaffModule } from "./feature/main/ecosystm-staff/ecosystm-staff.module";
import { TechAnalystPublicReportsComponent } from "@app/shared/components/tech-analyst-public-reports/tech-analyst-public-reports.component";
import { TechAnalystPublicUpcomingReportsComponent } from "@app/shared/components/tech-analyst-public-upcoming-reports/tech-analyst-public-upcoming-reports.component";
import { SignInComponent } from "./feature/sign-in/sign-in.component";
import { ConnectionsComponent } from "@app/feature/main/roles-shared/components/connections/connections.component";
import { ScheduleCallListComponent } from "@app/shared/components/schedule-call-list/schedule-call-list.component";
import { LinkComponent } from "./feature/external/link/link.component";
import { PrivacyPolicyComponent } from "@app/feature/external/privacy-policy/privacy-policy.component";
import { AboutUsComponent } from "@app/feature/external/about-us/about-us.component";
import { TechDomainsListComponent } from "@app/feature/main/roles-shared/components/tech-domains-list/tech-domains-list.component";
import { RulesAndRegulationsComponent } from "@app/feature/main/roles-shared/components/rules-and-regulations/rules-and-regulations.component";
import { LinkedinResolverService } from "./linkedin-resolver.service";
import { GlobalSearchPageComponent } from "./feature/main/roles-shared/global-search-page/global-search-page.component";
import { OurServicesComponent } from "@app/feature/external/our-services/our-services.component";
import { IndividualMarketdataComponent } from "./feature/main/roles-shared/components/individual-marketdata/individual-marketdata.component";
import { PackageSubscriptionComponent } from "./feature/main/roles-shared/components/package-subscription/package-subscription.component";

import { SsoGetResponseComponent } from "./feature/sso-get-response/sso-get-response.component";
import { SsoSignupResponseComponent } from "./feature/sso-signup-response/sso-signup-response.component";
import { PackageSubscriptionDetailsComponent } from "./feature/main/roles-shared/components/package-subscription-details/package-subscription-details.component";
import { AuthGuardAnalystService } from "./feature/main/tech-analyst/shared/services/auth-guard-analyst.service";

const appRoutes: Routes = [
  {
    path: "",
    component: PublicPageComponent,
    canActivate: [AuthGuard],
    resolve: {
      transaction: LinkedinResolverService,
    },
  },
  {
    path: "signin",
    component: SignInComponent,
    data: { title: "Ecosystm: Signin" },
    canActivate: [AuthGuard],
  },
  {
    path: "account",
    loadChildren: "./feature/external/account/account.module#AccountModule",
    canLoad: [AuthGuard],
  },
  {
    path: "tech-buyer",
    loadChildren: "./feature/main/tech-buyer/tech-buyer.module#TechBuyerModule",
    canLoad: [AuthGuard],
  },
  {
    path: "tech-vendor",
    loadChildren:
      "./feature/main/tech-vendor/tech-vendor.module#TechVendorModule",
    canLoad: [AuthGuard],
  },
  {
    path: "terms-of-use",
    component: TermsComponent,
    data: { title: "Ecosystm: Terms Of Use" },
  },
  {
    path: "research/all-research",
    component: AllResearchComponent,
    data: { title: "Ecosystm: All Market Data" },
  },
  {
    path: "all-research",
    redirectTo: "research/all-research",
    data: { title: "Ecosystm: All Market Data" },
  },
  {
    path: "all-market-data",
    component: AllResearchComponent,
    data: { title: "Ecosystm: All Market Data" },
  },
  {
    path: "all-market-data",
    redirectTo: "all-market-data",
  },
  {
    path: "tech-analyst",
    loadChildren:
      "./feature/main/tech-analyst/tech-analyst.module#TechAnalystModule",
    canLoad: [AuthGuard],
  },
  {
    path: "ecosystm-staff",
    loadChildren:
      "./feature/main/ecosystm-staff/ecosystm-staff.module#EcosystmStaffModule",
    canLoad: [AuthGuard],
  },
  {
    path: "analyst-list",
    component: AnalystListComponent,
    data: { title: "Ecosystm: Analyst List" },
    // canActivate: [AuthGuardBuyerService]
  },

  {
    path: "support",
    component: SupportComponent,
    data: { title: "Ecosystm: Support" },
  },
  {
    path: "reports",
    component: ReportsComponent,
    data: { title: "Ecosystm: Reports" },
  },
  {
    path: "package-subscription",
    component: PackageSubscriptionComponent,
  },
  {
    path: "package-subscription/package-details/:id",
    component: PackageSubscriptionDetailsComponent,
    data: { title: "Ecosystm: Package Subscription" },
    // canActivate: [AuthGuardAnalystService]
  },
  {
    path: "contact-us",
    component: ContactUsComponent,
    data: { title: "Ecosystm: Contact Us" },
  },
  {
    path: "link",
    component: LinkComponent,
    data: { title: "Ecosystm: Like" },
  },
  // {
  //   path: "blogs",
  //   component: BlogsComponent
  // },
  {
    path: "analyst-profile",
    component: TechAnalystProfileComponent,
    data: { title: "Ecosystm: Analyst Profile" },
  },
  {
    path: "public-profile-all-reports",
    component: TechAnalystPublicReportsComponent,
    data: { title: "Ecosystm: Public Profile All Reports" },
  },
  {
    path: "public-profile-upcoming-reports",
    component: TechAnalystPublicUpcomingReportsComponent,
    data: { title: "Ecosystm: Public Profile Upcoming Reports" },
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    data: { title: "Ecosystm: Privacy Policy" },
  },
  {
    path: "about-us",
    component: AboutUsComponent,
    data: { title: "Ecosystm: About Us" },
  },
  {
    path: "under-construction",
    component: UnderConstructionComponent,
  },
  {
    path: "tech-domain-list",
    component: TechDomainsListComponent,
  },
  {
    path: "rules-and-regulations",
    component: RulesAndRegulationsComponent,
  },
  {
    path: "our-services",
    component: OurServicesComponent,
    data: { title: "Ecosystm: Our Services" },
  },
  {
    path: "individual-market-data",
    component: IndividualMarketdataComponent,
    data: { title: "Ecosystm: Individual Market Data" },
  },
  {
    path: "sso",
    component: SsoGetResponseComponent,
  },
  {
    path: "sso-signup",
    component: SsoSignupResponseComponent,
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  // getAccountModule() {
  //   return AccountModule;
  // }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts